<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    mounted() {
      this.$i18n.locale='en';
    },
    created(){
      let islhToken = sessionStorage.getItem('islhtoken');
      if(!islhToken){
        let url = window.location.hash.replace('#', '') || '/';
        let path = url.split('?')[0];
        const whiteList = ['/login', '/satisfactionLevel', '/satisfactionLevelMarket'];
        if (!whiteList.some(item => path.startsWith(item))) {
          this.$router.push('/login');
        }
      }
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue